function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { SelectReact } from 'common/components/select';
import { ButtonSize } from 'common/components/button/constants';
import { SelectTheme } from 'common/components/select/constants';
import { InputReact } from 'common/components/input';
import { InputChangeEvent, InputSize } from 'common/components/input/types';
import { ChangeEvent } from 'common/components/select/types';
import { TimeUnit } from 'common/widgets/date-range-picker/models/types';
import { Property } from 'common/query-builder/query-block/properties-menu/types';
import styles from './index.module.styl';

/**
 * Defines a offset. used in both
 * SCDOffsetBlock
 * RevenueChangeBlock
 */
export function Offset(_ref: {
  value: Property[`scdOffset`];
  onChange: (offset: Property[`scdOffset`]) => void;
}) {
  let {
    value,
    onChange
  }: {
    value: Property[`scdOffset`];
    onChange: (offset: Property[`scdOffset`]) => void;
  } = _ref;
  if (!value) {
    return null;
  }
  const {
    value: offsetValue,
    unit
  } = value;
  return <div className={styles.customizeOffset} data-sentry-component="Offset" data-sentry-source-file="index.tsx">
      {offsetValue === "$start" && <div className={styles.startOfInterval}>As of start of Interval</div>}
      {typeof offsetValue === "number" && <>
          <div className={styles.text}>As of</div>
          <InputReact type='number' className={styles.input} min={"1"} size={InputSize.Small} value={"".concat(-offsetValue || 0)} onChange={(ev: InputChangeEvent) => {
        const changedValue = Number(ev.detail.value);
        onChange({
          value: -changedValue,
          unit
        });
      }} />
          <SelectReact theme={SelectTheme.QbSubitem} size={ButtonSize.Small} menuWidth={140} sections={[{
        items: [{
          label: "Days",
          value: TimeUnit.Day
        }, {
          label: "Weeks",
          value: TimeUnit.Week
        }, {
          label: "Months",
          value: TimeUnit.Month
        }, {
          label: "Quarters",
          value: TimeUnit.Quarter
        }, {
          label: "Years",
          value: TimeUnit.Year
        }].map(item => _objectSpread(_objectSpread({}, item), {}, {
          isSelected: item.value === unit
        }))
      }]} onChange={(ev: ChangeEvent<TimeUnit>) => {
        const {
          item
        } = ev.detail;
        onChange({
          value: offsetValue,
          unit: item.value
        });
      }} />
          <div className={styles.text}> ago</div>
        </>}
    </div>;
}